function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#fff}");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3639",
  className: "st0",
  d: "M86.66 33.25L28.83 66.5v33.25l29-16.63v66.83l28.83 16.63V66.5l29-16.63-29-16.62z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3640",
  className: "st0",
  d: "M115.66 82.96v67l28.83-16.63V66.5l-28.83 16.46z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_3642",
  className: "st0",
  d: "M87 200L0 149.96V50.04L87 0l87 50.04v99.92L87 200zM4.72 147.27L87 194.62l82.28-47.35V52.73L87 5.37 4.72 52.73v94.54z"
});

var SvgLogoIconLight = function SvgLogoIconLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 174 200",
    style: {
      enableBackground: "new 0 0 174 200"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIconLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon-light.beade831.svg";
export { ForwardRef as ReactComponent };